import { createContext } from "react";

/**
 * Lets a card lay out all its trends alike: each figure reports whether its own
 * trend fits beside it, and every trend moves below its label when any does not.
 */
export interface TrendLayout {
  report: (key: string, fits: boolean) => void;
  allFit: boolean;
}

export const TrendLayoutContext = createContext<TrendLayout | null>(null);
